// 关于用户登录

import * as types from '../mutation-types.js'

// state
const state = {
  logined: false,
  username: ''
}

// getters
const getters = {
  logined: state => {
    return state.logined
  },
  username: state => {
    return state.username
  }
}

// actions
const actions = {
  login ({commit}, username) {
    commit(types.USER_SIGNIN, username)
  },
  logout ({commit}) {
    commit(types.USER_SIGNOUT)
  }
}

// mutations
const mutations = {
  // 登录
  [types.USER_SIGNIN] (state, username) {
    state.username = username
    state.logined = true
  },
  // 登出
  [types.USER_SIGNOUT] (state) {
    state.username = ''
    state.logined = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
